/* Noorns redesign: the example report sign-up (snippets/noorns-example-signup.liquid).
   Carried from the live snippet's script (2026-10-07): the form is sent the normal way so
   Shopify's invisible human check runs and the page reloads at the box showing "Check your
   inbox". The script only catches a mistyped email first, copies the "Just the report"
   tag list into the hidden field when ticked, and remembers the address so the
   confirmation can name it. Guarded so it runs once even if loaded twice. */
(function () {
  if (window.__noornsXr) return;
  window.__noornsXr = true;
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var KEY = 'noorns-xr-email';
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest && e.target.closest('form[data-xr]');
    if (!form) return;
    var input = form.querySelector('input[type=email]');
    var err = form.querySelector('.xr-err');
    var email = ((input && input.value) || '').trim();
    if (!EMAIL.test(email)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      input.classList.add('is-error');
      if (err) err.hidden = false;
      input.focus();
      return;
    }
    input.value = email;
    var only = form.querySelector('[data-xr-only]');
    var tags = form.querySelector('input[type=hidden][name="contact[tags]"]');
    if (only && only.checked && tags) tags.value = only.value;
    try { sessionStorage.setItem(KEY, email); } catch (_) {}
    var btn = form.querySelector('.xr-btn');
    if (btn) btn.textContent = 'Sending...';
  }, true);

  function ready() {
    document.querySelectorAll('[data-xr-email]').forEach(function (el) {
      var email = '';
      try { email = sessionStorage.getItem(KEY) || ''; sessionStorage.removeItem(KEY); } catch (_) {}
      if (email) {
        el.textContent = email;
        var named = el.closest('[data-xr-named]');
        if (named) named.removeAttribute('hidden');
        var done = el.closest('.xr-done');
        var plain = done && done.querySelector('[data-xr-plain]');
        if (plain) plain.setAttribute('hidden', '');
      }
    });
    document.querySelectorAll('form[data-xr] .xr-input').forEach(function (input) {
      input.addEventListener('input', function () {
        input.classList.remove('is-error');
        var err = input.form && input.form.querySelector('.xr-err');
        if (err) err.hidden = true;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
